import React from 'react';
import { Modal, ModalProps, ScrollArea } from '@mantine/core';

interface ReusableModalProps extends ModalProps {
    children: React.ReactNode;
}

export const ReusableModal: React.FC<ReusableModalProps> = ({
    children,
    opened,
    onClose,
    title,
    size = 'lg',
    padding = 'lg',
    ...props
}) => {
    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title={title}
            size={size}
            padding={padding}
            scrollAreaComponent={ScrollArea.Autosize}
            closeOnClickOutside={false}
            centered
            {...props}
        >
            {children}
        </Modal>
    );
};
